import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, NgModule, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ListLoadingIndicatorComponent, LoadingAttributeComponent } from '@shared/ui';

export interface AssetTypeListItem {
  id: string;
  name: string;
  type: 'image' | 'video' | 'text' | 'audio';
  supportedDevices: number;
  usedByCaseTypes?: number;
  usedByMethodTypes?: number;
}

export enum AssetTypeColumn {
  TYPE = 'type',
  NAME = 'assetType',
  USED_BY_CASE_TYPES = 'usedByCaseTypes',
  USED_BY_METHOD_TYPES = 'usedByMethodTypes',
  COMPATIBLE_DEVICES = 'compatibleDevices',
  EDIT = 'edit',
  DELETE = 'delete',
}

@Component({
    selector: 'ts-asset-types-list',
    templateUrl: './asset-types-list.component.html',
    styleUrls: ['./asset-types-list.component.scss'],
    standalone: false
})
export class AssetTypesListComponent implements OnChanges {
  @Input() items: AssetTypeListItem[] = [];
  @Input() loading = false;
  @Input() noAssetTypes = false;
  @Input() columns: AssetTypeColumn[] = [
    AssetTypeColumn.TYPE,
    AssetTypeColumn.NAME,
    AssetTypeColumn.USED_BY_CASE_TYPES,
    AssetTypeColumn.USED_BY_METHOD_TYPES,
    AssetTypeColumn.COMPATIBLE_DEVICES,
    AssetTypeColumn.EDIT,
    AssetTypeColumn.DELETE,
  ];

  @Output() editClicked = new EventEmitter<AssetTypeListItem>();
  @Output() deleteClicked = new EventEmitter<AssetTypeListItem>();

  // Store the container height when loading starts to prevent layout jumps
  public containerHeight: number | null = null;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    // When loading starts, capture the current height
    if (changes['loading'] && changes['loading'].currentValue === true) {
      const element = this.elementRef.nativeElement as HTMLElement;
      if (element && element.offsetHeight > 0) {
        this.containerHeight = element.offsetHeight;
      }
    }
    // When loading ends, clear the fixed height
    if (changes['loading'] && changes['loading'].currentValue === false) {
      this.containerHeight = null;
    }
  }

  get visibleColumns(): string[] {
    return this.columns.map((col) => col.valueOf());
  }
}

@NgModule({
  declarations: [AssetTypesListComponent],
  exports: [AssetTypesListComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    LoadingAttributeComponent,
    ListLoadingIndicatorComponent,
  ],
})
export class AssetTypesListComponentModule {}
